import AiAgentChat, { AiAgentChatRef } from 'components/AiAgentChat';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { FC, useRef } from 'react';
import InvestmentProposalCard from './InvestmentProposalCard';

type Props = {
  vehicleId: string;
};

const AiAgent: FC<Props> = ({ vehicleId }) => {
  const chatRef = useRef<AiAgentChatRef>(null);
  const utils = api.useUtils();

  const chatMutation = api.aiAgent.chatInvestment.useMutation(
    useHandleTrpcMutation()({
      invalidations: [],
    }),
  );
  const executeMutation = api.aiAgent.executeInvestment.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Investment draft created successfully',
      onSuccess: () => {
        utils.lpInvestment.list.invalidate();
        chatRef.current?.addMessage({
          role: 'assistant',
          content:
            'The investment draft has been created successfully! You can see it in the list below. Edit it to complete the allocation and approve it.',
        });
      },
    }),
  );

  return (
    <AiAgentChat
      ref={chatRef}
      vehicleId={vehicleId}
      description="Upload a subscription agreement or describe an investment to create"
      dropzoneMessage="Drag and drop a subscription agreement, or click to search"
      inputPlaceholder="Describe the investment you want to create..."
      isExecuting={executeMutation.isPending}
      onChat={(params) => chatMutation.mutateAsync(params)}
      onApproveProposal={(proposal) =>
        executeMutation.mutate({ vehicleId, proposal })
      }
      renderProposalCard={(props) => (
        <InvestmentProposalCard
          proposal={props.proposal}
          vehicleId={props.vehicleId}
          onApprove={props.onApprove}
          onReject={props.onReject}
          isExecuting={props.isExecuting}
        />
      )}
    />
  );
};

export default AiAgent;
